import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import {Tab, Tabs} from 'material-ui/Tabs';
import DatePicker from 'material-ui/DatePicker';
import Cropper from 'react-cropper';
import Chip from 'material-ui/Chip';
import CircularProgress from 'material-ui/CircularProgress';


import {closeAddEventForm, updateField, updateEvent, changeImage, cancelImage, displayError, showSpinner} from '../../actions/events'
import {showUpdateSessionForm, deleteSession} from '../../actions/sessions'
import 'cropperjs/dist/cropper.css';

import moment from 'moment-timezone'

import AddSession from '../sessions/AddSession'

const leftPanelStyle = {
  float: 'left',
  width: '50%'
}

const rightPanelStyle = {
  float: 'right',
  padding: 10,
  width: '45%'
}

const customContentStyle = {
  width: '50%',
  maxWidth: 'none',
};

const styles = {

  sessionButton: {
    verticalAlign: 'middle',
  },
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  chip: {
    margin: 4,
    float: 'left'
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  tab: {
    minHeight: 400
  }
};

class AddEvent extends Component {

  static defaultProps = {
    src: '',
    showSpinner:false
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  updateSession(session) {
    const { dispatch } = this.props
    dispatch(showUpdateSessionForm(session))
  }

  deleteSession(session) {
    const { dispatch } = this.props
    dispatch(deleteSession(session))
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddEventForm())
  }

  updateEvent() {
    this.showSpinner()
    const { dispatch } = this.props

    if (!this.props.event.eventLink.title || this.props.event.eventLink.title.length === 0) {
      return dispatch(displayError("Event name is mandatory!"))
    }

    if (!this.props.event.eventLink.desc || this.props.event.eventLink.desc.length === 0) {
      return dispatch(displayError("Event description is mandatory!"))
    }

    if (!this.props.event.eventDate) {
      return dispatch(displayError("Please specify a starting date for this event!"))
    }

    if (!this.props.event.capacity) {
      return dispatch(displayError("Please specify the capacity for this event!"))
    }

    if (this.props.event.capacity != undefined && this.props.event.capacity.toString().match(/[a-z]/i)) {
      return dispatch(displayError("Capacity must be a numeric value!"))
    }

    if (!this.props.event.building && !this.props.event.company) {
      return dispatch(displayError("Please specify at least one company or building for this event!"))
    }

    if (!this.props.event.listImage && !this.props.event.newImage) {
      return dispatch(displayError("Please add an image for this event!"))
    }

    if (!this.props.event.sessions || this.props.event.sessions.length === 0) {
      return dispatch(displayError("Please add at least one session for this event!"))
    }

    // update sessions time based on event start date
    if (this.props.event.sessions && this.props.event.sessions.length > 0) {
      for (var session of this.props.event.sessions) {

        let sessionTime = moment(session.startDateTime)
        let eventDate = moment(this.props.event.eventDate)
        let newSessionTime = moment().tz('America/New_York')

        newSessionTime.year(eventDate.year())
        newSessionTime.month(eventDate.month())
        newSessionTime.date(eventDate.date())
        newSessionTime.hour(sessionTime.hour())
        newSessionTime.minute(sessionTime.minute())

        session.startDateTime = newSessionTime.toDate()
      }
    }



    dispatch(updateEvent(this.props.event))
  }

  updateField(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value))
  }

  updateSelectField(name, event, index, value) {
    const { dispatch } = this.props
    dispatch(updateField(name, value))
  }

  updateStartDate(name, event, date) {
    const { dispatch } = this.props
    var eventDate = moment(date)
    eventDate.hours(0)
    eventDate.minutes(0)
    eventDate.seconds(1)
    dispatch(updateField(name, eventDate.toDate().toString()))
  }

  updateEventLink(event, index, value) {
    const { dispatch } = this.props

    var eventLink = {title: '', desc: ''}

    if (value !== null) {
      eventLink = this.props.eventsLinks.find(e => e._id === value)
    }

    dispatch(updateField('eventLink', eventLink))
  }

  updateEventLinkField(event) {
    const { dispatch } = this.props
    var eventLink = {...this.props.event.eventLink, [event.target.name]: event.target.value}

    dispatch(updateField('eventLink', eventLink))
  }

  updateCompany(event, index, value) {
    const { dispatch } = this.props

    var company = {}

    if (value !== null) {
      company = this.props.companies.find(e => e._id === value)
    }

    dispatch(updateField('company', company))
  }

  updateBuilding(event, index, value) {
    const { dispatch } = this.props

    var building = {}

    if (value !== null) {
      building = this.props.buildings.find(e => e._id === value)
    }

    dispatch(updateField('building', building))
  }

  cancelImage(event) {
    const { dispatch } = this.props
    dispatch(cancelImage())
  }

  onImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault();
    let files;
    if (event.dataTransfer) {
      files = event.dataTransfer.files;
    } else if (event.target) {
      files = event.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      dispatch(changeImage(reader.result))
    };
    reader.readAsDataURL(files[0]);
  }

  cropImage() {
    const { dispatch } = this.props

    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return;
    }

    dispatch(changeImage(this.cropper.getCroppedCanvas().toDataURL()))
  }

  handleSessionDelete(session) {
    const { dispatch } = this.props
    dispatch(deleteSession(session))
  }

  handleSessionSelect(session) {
    const { dispatch } = this.props
    dispatch(showUpdateSessionForm(session))
  }

  showSessionForm() {
    const { dispatch } = this.props
    dispatch(showUpdateSessionForm({startDateTime: moment()}))
  }

  showSpinner() {
    const { dispatch} = this.props  
    dispatch(showSpinner())
  }

  render() {

    if (this.props.event) {

      if (this.props.event.eventLink == null) {
        this.props.event.eventLink = {}
      }

      const actions = [
        <div>
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeDialog.bind(this)}
          />
          {(this.props.showSpinner && this.props.error == undefined )? (<CircularProgress style={{paddingLeft: '59px', paddingRight: '59px', verticalAlign: 'middle' }} size={20} thickness={1} />)
          :
          (<FlatButton
            label={this.props.event._id == null ? "Add Event" : "Update Event"}
            primary={true}
            onClick={this.updateEvent.bind(this)}
          />)}
        </div>
      ];

      return (<Dialog
        contentStyle={customContentStyle}
        autoScrollBodyContent={true}
        autoDetectWindowHeight={true}
        actions={actions}
        modal={true}
        open={this.props.event != null}>

        <Tabs>
          <Tab label="General Info" >
            <div style={styles.tab}>
              <div style={leftPanelStyle}>
                <SelectField
                  name="eventLink"
                  floatingLabelText="Event Link"
                  onChange={this.updateEventLink.bind(this)}
                  value={this.props.event.eventLink._id}
                >
                  <MenuItem
                    value={null}
                    primaryText="New Event Link"
                    checked={this.props.event.eventLink && this.props.event.eventLink._id === undefined}
                  />
                  {this.props.eventsLinks.map((eventLink, index) =>
                    <MenuItem
                      value={eventLink._id}
                      primaryText={eventLink.title}
                      checked={this.props.event.eventLink && this.props.event.eventLink._id === eventLink._id}
                    />
                  )}
                </SelectField>

                <br />
                <TextField
                  name="title"
                  //disabled={this.props.event.eventLink._id != null}
                  hintText="Name"
                  floatingLabelText="Name"
                  value={this.props.event.eventLink.title}
                  onChange={this.updateEventLinkField.bind(this)}
                />
                <br />
                <TextField
                  name="desc"
                  //disabled={this.props.event.eventLink._id != null}
                  hintText="Description"
                  floatingLabelText="Description"
                  multiLine={true}
                  rows={4}
                  rowsMax={4}
                  value={this.props.event.eventLink.desc}
                  onChange={this.updateEventLinkField.bind(this)}
                />
                <br />
              </div>
              <div style={rightPanelStyle}>
                <DatePicker
                  hintText="Start Date"
                  name="eventDate"
                  value={this.props.event.eventDate ? new Date(this.props.event.eventDate) : null}
                  onChange={this.updateStartDate.bind(this, "eventDate")}
                />
                <br />
                <TextField
                  name="capacity"
                  hintText="Capacity"
                  floatingLabelText="Capacity"
                  value={this.props.event.capacity}
                  onChange={this.updateField.bind(this)}
                />
                <br />
                <SelectField
                  name="company"
                  floatingLabelText="Company"
                  onChange={this.updateCompany.bind(this)}
                  value={this.props.event.company ? this.props.event.company._id : ''}
                >
                  {this.props.companies.map((company, index) =>
                    <MenuItem
                      value={company._id}
                      primaryText={company.name}
                      checked={this.props.event.company && this.props.event.company._id === company._id}
                    />
                  )}
                </SelectField>
                <br />
                <SelectField
                  name="building"
                  floatingLabelText="Building"
                  onChange={this.updateBuilding.bind(this)}
                  value={this.props.event.building ? this.props.event.building._id : ''}
                >
                  {this.props.buildings.map((building, index) =>
                    <MenuItem
                      value={building._id}
                      primaryText={building.name}
                      checked={this.props.event.building && this.props.event.building._id === building._id}
                    />
                  )}
                </SelectField>
                <br />
                <TextField
                  name="location"
                  hintText="Location"
                  floatingLabelText="Location"
                  value={this.props.event.location}
                  onChange={this.updateField.bind(this)}
                />
              </div>
            </div>
          </Tab>
          <Tab label="Image" >
            <div style={styles.tab}>
              <Cropper
                style={{height: 400, width: '100%' }}
                aspectRatio={16 / 9}
                guides={false}
                //crop={this.cropImage.bind(this)}
                src={this.props.event.newImage ? this.props.event.newImage : this.props.event.listImage }
                ref={cropper => { this.cropper = cropper; }}
              />
              <br />
              {this.props.event.newImage ?
              <FlatButton
                fullWidth={true}
                label="Cancel"
                labelPosition="before"
                style={styles.uploadButton}
                containerElement="label"
                onClick={this.cancelImage.bind(this)}
              /> : null }
                <br/>

                <FlatButton
                  fullWidth={true}
                  label="Crop"
                  labelPosition="before"
                  style={styles.uploadButton}
                  containerElement="label"
                  onClick={this.cropImage.bind(this)}
                />
              <br />
              <FlatButton
                fullWidth={true}
                label={this.props.event.listImage ? "Change Image" :"Choose an Image"}
                labelPosition="before"
                style={styles.uploadButton}
                containerElement="label"
              >
                <input type="file" style={styles.uploadInput} onChange={this.onImageChange.bind(this)} />
              </FlatButton>
            </div>
          </Tab>
          <Tab label="Sessions">
            <div style={styles.tab}>
              <AddSession />
              <br/>
              {this.props.event.sessions && this.props.event.sessions.length > 0 ? this.props.event.sessions.map((session, index) =>
                <Chip
                  onRequestDelete={this.handleSessionDelete.bind(this, session)}
                  onClick={this.handleSessionSelect.bind(this, session)}
                  style={styles.chip}>
                  {moment(session.startDateTime).format("h:mm a")}
                </Chip>
              ) : (<p>No sessions</p>)}
              <br/>
              <FlatButton
                label="Add Session"
                fullWidth={true}
                primary={true}
                style={styles.sessionButton}
                onClick={this.showSessionForm.bind(this)}
              />
              
            </div>
          </Tab>
        </Tabs>
        <div style={{color: "red"}}>
          {this.props.error}
        </div>
      </Dialog>)
    } else {
      return (<div />)
    }

  }
}

const mapStateToProps = state => {
  return state.eventsReducer
}

export default withRouter(
  connect(mapStateToProps)(AddEvent)
);



// WEBPACK FOOTER //
// ./src/components/events/AddEvent.js